export default __webpack_public_path__ + "static/media/mission2.c2df5e32.svg";